<template>
    <div class="shop-tab">
        <div class="h-100">
            <div class="shop-tab-holder col-md-6 h-100">
                <div v-if="jokers.length > 0" class="shopHolder jokers">
                    <h4>{{ $t('shop.shop_jokers_title') }}</h4>
                    <div class="row m-2">
                        <div v-for="(p, index) in jokers" :key="'j_'+p.id" class="col-4 p-0">
                            <div @click.prevent="buyJokers(p); btnSfx();" class="shopListItem">
                                <img :src="'/images/shop/jokers/'+(index +1)+'.png'"/>
                                <div>{{ p.amount.toLocaleString('sr-RS') }}</div>
                                <b-button variant="primary" size="sm" class="btn-block">
                                    <img src="/images/token.png"/>
                                    {{ p.price.abbr(true) }}
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="challengeAccessible && (swapperJokers.length > 0 || swapperTokens.length > 0)" class="shopHolder swappers">
                    <h4>{{ $t('shop.shop_swappers_title') }}</h4>
                    <div class="row m-2">
                        <div v-for="(p, index) in swapperJokers" :key="'sj_'+p.id"  class="col-4 p-0">
                            <div @click.prevent="buySwapperJokers(p); btnSfx();" class="shopListItem joker">
                                <img :src="'/images/shop/swapper-joker/'+(index +1)+'.png'"/>
                                <div>{{ p.amount.toLocaleString('sr-RS') }}</div>
                                <b-button variant="primary" size="sm" class="btn-block">
                                    <img src="/images/joker.png"/>
                                    {{ p.price.abbr() }}
                                </b-button>
                            </div>
                        </div>
                        <div v-for="(p, index) in swapperTokens" :key="'st_'+p.id"  class="col-4 p-0">
                            <div @click.prevent="buySwapperTokes(p); btnSfx();" class="shopListItem">
                                <img :src="'/images/shop/swapper-token/'+(index +1)+'.png'"/>
                                <div>{{ p.amount.toLocaleString('sr-RS') }}</div>
                                <b-button variant="primary" size="sm" class="btn-block">
                                    <img src="/images/token.png"/>
                                    {{ p.price.abbr(true) }}
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="diamonds.length > 0" class="shopHolder diamonds">
                    <h4>{{ $t('shop.shop_diamonds_title') }}</h4>
                    <div class="row m-2">
                        <div v-for="(p, index) in diamonds" :key="'d_'+p.id"  class="col-4 p-0">
                            <div @click.prevent="buyDiamonds(p); btnSfx();" class="shopListItem">
                                <img :src="'/images/shop/diamonds/'+(index +1)+'.png'"/>
                                <div>{{ p.amount.toLocaleString('sr-RS') }}</div>
                                <b-button variant="primary" size="sm" class="btn-block">
                                    <img src="/images/token.png"/>
                                    {{ p.price.abbr(true) }}
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="mtsPointPackages.length > 0" class="shopHolder mtsPointPackages">
                    <h4>{{ $t('shop.shop_mts_points_title') }}</h4>
                    <div class="row m-2">
                        <div v-for="(p, index) in mtsPointPackages" :key="'d_'+p.id"  class="col-4 p-0">
                            <div @click.prevent="buyMtsPointPackages(p); btnSfx();" class="shopListItem">
                                <img :src="'/images/shop/mts-points/'+(index +1)+'.png'"/>
                                <div>{{ p.amount.toLocaleString('sr-RS') }}</div>
                                <b-button variant="primary" size="sm" class="btn-block">
                                    <img src="/images/diamond.png"/>
                                    {{ p.price.abbr() }}
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="cheques.length > 0 || vouchers.length > 0" class="shopHolder chequesVouchers mb-0">
                    <h4>{{ $t('shop.shop_cheques_title') }}</h4>
                    <div class="holder">
                        <div v-if="1 == 2" class="mt-3">{{ $t('shop.shop_cheques_subtitle') }}</div>
                        <div class="chequesTabs d-flex mt-3 pl-3 pr-3">
                            <a href="#" v-if="vouchers.length > 0" @click.prevent="tab = 'vouchers'; btnSfx();" :class="tab == 'vouchers' ? 'active' : ''">{{ $t('shop.shop_vouchers_tab') }}</a>
                            <a href="#" v-if="cheques.length > 0" @click.prevent="tab = 'BANK'; btnSfx();" :class="tab == 'BANK' ? 'active' : ''">{{ $t('shop.shop_cheques_tab_bank') }}</a>
                            <a href="#" v-if="cheques.length > 0" @click.prevent="tab = 'POST'; btnSfx();" :class="tab == 'POST' ? 'active post' : 'post'"><span></span>{{ $t('shop.shop_cheques_tab_post') }}</a>
                        </div>
                        <ul>
                            <li v-for="c in cheques.filter(c => tab == c.paymentMethod)" :key="'ch_'+c.id" class="chequeListItem" :style="'background:#'+c.color+';'">
                                <div @click.prevent="buyCheque(c); btnSfx();">
                                    <p>{{ $t('shop.cheques_item_title') }}</p>
                                    <h2 :style="'color:#'+c.color+';'">{{ c.amount.toLocaleString('sr-RS') }}</h2>
                                    <span>{{ $t('shop.cheques_item_currency') }}</span>
                                    <b-button variant="primary" size="sm">
                                        <img src="/images/diamond.png" class="mr-2" />
                                        {{ c.price.abbr() }}
                                    </b-button>
                                </div>
                            </li>

                            <li v-for="c in vouchers.filter(x => tab == 'vouchers')" :key="'vo_'+c.id" class="voucherListItem">
                                <div @click.prevent="buyVoucher(c); btnSfx();">
                                    <img :src="c.imageUrl" :alt="c.name"/>
                                    <h5>{{ c.name }}</h5>
                                    <div>{{ $t('shop.voucher_item_subtitle') }}</div>
                                    <h3 class="text-primary"><b>{{ c.amount.toLocaleString('sr-RS') }} RSD</b></h3>
                                    <i></i>
                                    <div class="price">
                                        <div>{{ $t('shop.voucher_item_price') }}</div>
                                        <img src="/images/diamond.png" class="mr-1" />
                                        {{ c.price.abbr() }}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <cheque-popup ref="chequePopup" @updated="$emit('changeTab','profile')"></cheque-popup>
        <voucher-popup ref="voucherPopup" @updated="$emit('changeTab','profile')"></voucher-popup>
    </div>
</template>
<script>
import Vue from 'vue'
import api from '../../api'

import ChequePopup from '../ChequePopup.vue';
import VoucherPopup from '../VoucherPopup.vue';

const ShopTab = Vue.component('shop-tab', {
    components: {
        ChequePopup, VoucherPopup
    },
    data(){
    	return {
            tab: 'vouchers',
    	};
    },

    methods:{

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        hasMoney(price, type){
            if((type == "diamonds" && price > this.user.diamonds) 
                || (type == "tokens" && price > this.user.tokens
                || (type == "jokers" && price > this.user.jokers)) ){
                
                this.$root.$bvModal.msgBoxOk(this.$t('shop.shop_no_'+type), {
                    title: this.$t('shop.shop_no_resources_title'),
                    size: 'sm',
                    buttonSize: 'lg',
                    okTitle: this.$t('base.btn_ok'),
                    modalClass: 'confirmModal',
                    hideHeaderClose: false,
                    centered: true
                }).then(value => {
                    this.$store.dispatch('sound/sfx','Button');
                });

                return false;
            }
            return true;
        },

        successInfo(value, type){
            this.$root.$bvModal.msgBoxOk(this.$t('shop.shop_buy_success_'+type+'_text', { value: value }), {
                    title: this.$t('shop.shop_buy_success_'+type+'_title'),
                    size: 'sm',
                    buttonSize: 'lg',
                    okTitle: this.$t('base.btn_ok'),
                    modalClass: 'confirmModal',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    this.$store.dispatch('sound/sfx','Button');
                });
        },


        buyJokers(p){
            // check user has money
            if(!this.hasMoney(p.price, 'tokens')) return;
            
            const $this = this;
            // confirm first
            this.$bvModal.msgBoxConfirm(this.$t('shop.shop_buy_item_popup_jockers_text', { amount: p.amount.toLocaleString('sr-RS'), price: p.price.abbr(true) }), {
                title: this.$t('shop.shop_buy_item_popup_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: p.price.abbr(true),
                cancelTitle: this.$t('base.btn_cancel'),
                modalClass: 'confirmModal shopByTokens',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    api.shopBuyJokers(p.id).then(function (response) {
                        // no actions
                        $this.successInfo(p.amount.toLocaleString('sr-RS'), 'jokers');
                        $this.$store.dispatch('auth/getMe');
                    })
                    .catch(function (error) {
                        api.baseErrorHendler(error);
                    })
                }
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        },

        buyDiamonds(p){
            if(!this.hasMoney(p.price, 'tokens')) return;
            
            const $this = this;
            // confirm first
            this.$bvModal.msgBoxConfirm(this.$t('shop.shop_buy_item_popup_diamonds_text', { amount: p.amount.toLocaleString('sr-RS'), price: p.price.abbr(true) }), {
                title: this.$t('shop.shop_buy_item_popup_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: p.price.abbr(true),
                cancelTitle: this.$t('base.btn_cancel'),
                modalClass: 'confirmModal shopByTokens',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    api.shopBuyDiamonds(p.id).then(function (response) {
                        // no actions
                        $this.successInfo(p.amount.toLocaleString('sr-RS'), 'diamonds');
                        $this.$store.dispatch('auth/getMe');
                    })
                    .catch(function (error) {
                        api.baseErrorHendler(error);
                    })
                }
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        },

        buyMtsPointPackages(p){
            if(!this.hasMoney(p.price, 'diamonds')) return;
            
            const $this = this;
            // confirm first
            this.$bvModal.msgBoxConfirm(this.$t('shop.shop_buy_item_popup_mts_points_text', { amount: p.amount.toLocaleString('sr-RS'), price: p.price.abbr() }), {
                title: this.$t('shop.shop_buy_item_popup_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: p.price.abbr(),
                cancelTitle: this.$t('base.btn_cancel'),
                modalClass: 'confirmModal shopBuyDiamonds',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    api.shopBuyMtsPointPackages(p.id).then(function (response) {
                        // no actions
                        $this.successInfo(p.amount.toLocaleString('sr-RS'), 'mts_points');
                        $this.$store.dispatch('auth/getMe');
                    })
                    .catch(function (error) {
                        api.baseErrorHendler(error);
                    })
                }
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        },


        buySwapperTokes(p){
            if(!this.hasMoney(p.price, 'tokens')) return;
            
            const $this = this;
            // confirm first
            this.$bvModal.msgBoxConfirm(this.$t('shop.shop_buy_item_popup_swapper_tokens_text', { amount: p.amount.toLocaleString('sr-RS'), price: p.price.abbr(true) }), {
                title: this.$t('shop.shop_buy_item_popup_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: p.price.abbr(true),
                cancelTitle: this.$t('base.btn_cancel'),
                modalClass: 'confirmModal shopByTokens',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    api.shopBuySwapperTokens(p.id).then(function (response) {
                        // no actions
                        $this.successInfo(p.amount.toLocaleString('sr-RS'), 'swapper_tokens');
                        $this.$store.dispatch('auth/getMe');
                    })
                    .catch(function (error) {
                        api.baseErrorHendler(error);
                    })
                }
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        },

        buySwapperJokers(p){
            if(!this.hasMoney(p.price, 'jokers')) return;
            
            const $this = this;
            // confirm first
            this.$bvModal.msgBoxConfirm(this.$t('shop.shop_buy_item_popup_swapper_jokers_text', { amount: p.amount.toLocaleString('sr-RS'), price: p.price.abbr() }), {
                title: this.$t('shop.shop_buy_item_popup_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: p.price.abbr(),
                cancelTitle: this.$t('base.btn_cancel'),
                modalClass: 'confirmModal shopByJokers',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    api.shopBuySwapperJokers(p.id).then(function (response) {
                        // no actions
                        $this.successInfo(p.amount.toLocaleString('sr-RS'), 'swapper_jokers');
                        $this.$store.dispatch('auth/getMe');
                    })
                    .catch(function (error) {
                        api.baseErrorHendler(error);
                    })
                }
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        },


        buyCheque(c){
            this.$refs.chequePopup.showBuyForm(c);
        },

        buyVoucher(c){
            this.$refs.voucherPopup.showBuyForm(c);
        }
        
    },

    mounted(){
        this.$store.dispatch('sound/bg','BG_Shop');
    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        },
        jokers() {
            return this.$store.state.shop.data.jokerPackages;
        },
        diamonds() {
            return this.$store.state.shop.data.diamondPackages;
        },
        mtsPointPackages() {
            return this.$store.state.shop.data.mtsPointPackages;
        },
        cheques() {
            return this.$store.state.shop.data.cheques;
        },
        swapperTokens(){
            return this.$store.state.shop.data.swapperTokenPackages;
        },
        swapperJokers(){
            return this.$store.state.shop.data.swapperJokerPackages;
        },
        vouchers(){
            if(this.tab == 'vouchers' && this.$store.state.shop.data.vouchers.length == 0) this.tab = 'BANK'; 
            return this.$store.state.shop.data.vouchers;
        },
        challengeAccessible(){
            return this.$store.state.config.data.challengeAccessible;
        }
    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
    },
});

export default ShopTab
</script>
